import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth0 } from '@auth0/auth0-react';
import { CircularProgress } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useClaims from '@/hooks/useClaims';
/*
 * authorization callback/landing page
 * redirects unauthenticated users to login
 * exchanges authorization_code for access_token
 * fetches user metadata, navigates to relevant page
 */
const OAuthCallback = () => {
    const [searchParams] = useSearchParams();
    const { isLoading, isAuthenticated, error } = useAuth0();
    const { loadUserMetadata } = useClaims();
    const navigate = useNavigate();
    const replace = useCallback((pathname, e) => {
        const error = e ? `${e instanceof Error ? e.message : e}` : undefined;
        const search = error && new URLSearchParams({ error }).toString();
        navigate({ pathname, search }, { replace: true });
    }, [navigate]);
    const findNumOwners = useCallback(async () => {
        try {
            const metadata = await loadUserMetadata();
            return metadata?.owner_ids?.length ?? 0;
        }
        catch (e) {
            console.error(e);
            replace('/login', 'common.invalidUser');
        }
        return 0;
    }, [loadUserMetadata, replace]);
    const redirectUser = useCallback(async () => {
        if (error || !isAuthenticated) {
            return replace('/login', error || searchParams.get('error'));
        }
        const numOwners = await findNumOwners();
        replace(numOwners === 1 ? '/companies' : '/owners');
    }, [error, findNumOwners, isAuthenticated, replace, searchParams]);
    useEffect(() => {
        if (!isLoading) {
            redirectUser();
        }
    }, [isLoading, redirectUser]);
    return _jsx(CircularProgress, { "data-testid": "loader" });
};
export default OAuthCallback;
